//引入路由
import { createRouter, createWebHashHistory } from 'vue-router'
import Home from '@/pages/Home'
import Product from '@/pages/Product'
import News from '@/pages/News'
import Contact from '@/pages/Contact'
import NewsList from '@/pages/News/NewsList'
import Excellect from '@/pages/Excellect'
import Service from '@/pages/Service'
export default createRouter({

    history: createWebHashHistory(),
    routes: [{
        name: "home",
        path: '/home',
        component: Home,
    },
   
    {
        name: "product",
        path: '/product',
        component: Product,
    },
    {
        name: "news",
        path: '/news',
        component: News,
        children: [
        {
            path: "newslist",
            component: NewsList
        },
        {
            path: '/news',
            redirect: "/news/newslist"
        }
        ]
    },
    {
        name: "contact",
        path: '/contact',
        component: Contact
    },

    {
        name: "excellect",
        path: '/excellect',
        component: Excellect
    },

    {
        name: "service",
        path: '/service',
        component: Service
    },

    {
        path: '/',
        redirect: "/home"
    }
    ],
    scrollBehavior() {
        return { top: 0 }
    },
})